import React from "react";

interface SelectProps {
  name: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fullWidth?: boolean;
  startAdornment?: React.ReactNode;
  options: { label: string; value: string }[];
  labelClassName?: string;
}

const Select: React.FC<SelectProps> = ({
  name,
  label,
  value,
  onChange,
  fullWidth = false,
  startAdornment,
  options,
  labelClassName,
  ...props
}) => {
  return (
    <div className="flex flex-col">
      {label && (
        <label
          htmlFor={name}
          className={`block text-sm font-medium text-[var(--text-secondary)] mb-2 ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <div
        className={`bg-white flex items-center border border-gray-300 rounded-md overflow-hidden ${
          fullWidth ? "w-full" : "w-fit"
        }`}
      >
        {startAdornment && (
          <div className="flex items-center gap-2 pl-1 text-gray-400">
            {startAdornment}
          </div>
        )}
        <select
          className={`p-2 px-1 h-10 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-transparent placeholder:text-gray-400 placeholder:text-sm disabled:text-gray-400 ${
            fullWidth ? "w-full" : "w-fit"
          }`}
          name={name}
          value={value}
          onChange={onChange}
          {...props}
        >
          <option value="" disabled>
            Select
          </option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Select;
